export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

export const DEFAULT_DATE_FNS_FORMAT = 'dd/MM/yyyy';

export const DEFAULT_DATE_TIME_FORMAT = 'HH:mm DD/MM/YYYY';

export const SUBSCRIPTION_STATUS = {
  TRIAL: 'TRIAL',
  TRIAL_EXPIRED: 'TRIAL_EXPIRED',
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED',
};

export const WEEK_MAPPING = {
  0: 'Thứ 2',
  1: 'Thứ 3',
  2: 'Thứ 4',
  3: 'Thứ 5',
  4: 'Thứ 6',
  5: 'Thứ 7',
  6: 'Chủ nhật',
};

export const FILTER_DATE = [
  { name: 'Ngày', value: 'day' },
  { name: 'Tuần', value: 'week' },
  { name: 'Tháng', value: 'month' },
];

export const PRESCRIPTION_TYPE = {
  OTC: 'otc',
  RX: 'rx',
};

export const DEFAULT_TABLE_SCROLL_X = 1024;

export const POS_ITEM_TYPE = {
  PRODUCT: 'product',
  FOLDER: 'folder',
  PRESCRIPTION_TEMPLATE: 'prescription_template',
  PRESCRIPTION: 'prescription',
};

// sale - return - exchange
export const POS_ORDER_TYPE = {
  SALE: 'sale',
  RETURN: 'return',
  EXCHANGE: 'exchange',
};

// parked - paid - cancelled
export const POS_ORDER_STATUS = {
  PARKED: 'parked',
  PAID: 'paid',
  CANCELLED: 'cancelled',
};

// pos - checkout - print
export const POS_STEP = {
  POS: 'pos',
  CHECKOUT: 'checkout',
  EXCHANGE: 'exchange',
};

// percent - amount
export const POS_DISCOUNT_TYPE = {
  PERCENT: 'percent',
  AMOUNT: 'amount',
};

export const PRODUCT_TRACKING_TYPE = {
  TRACKING_TYPE_NONE: 'none',
  TRACKING_TYPE_BASIC: 'basic',
  TRACKING_TYPE_LOT: 'lot',
  TRACKING_TYPE_SERIAL: 'serial',
};
export const REASON = [
  { name: 'Ngày', value: 'day' },
  { name: 'Tuần', value: 'week' },
  { name: 'Tháng', value: 'month' },
];
export const QUALITY_REASON = [
  { name: 'Đột xuất', value: 'SPOT' },
  { name: 'Định kỳ', value: 'PERIODIC' },
];
export const CUSTOMER = [{ name: 'Tri', value: 2 }];

export const COMMENT_REASON = [
  { name: 'Đạt', value: 'ACCEPT' },
  { name: 'Không đạt', value: 'REJECT' },
  { name: 'Sửa chữa', value: 'REPAIR' },
  { name: 'Loại bỏ', value: 'SCRAP' },
  { name: 'Trả hàng', value: 'RETURN' },
  { name: 'Khác', value: 'OTHER' },
];

export const ItemStatus = Object.freeze({
  ADDED: 'added',
  REMOVED: 'removed',
  MODIFIED: 'modified',
  UNCHANGED: 'unchanged',
});

export const TENANT_TYPE = {
  PHARMACY: 'pharmacy',
  CLINIC: 'clinic',
  PHARMA_COMPANY: 'pharma_company',
};
